<template>
  <div class="flex w-full items-center gap-2" :class="wrapperClass">
    <div :class="['relative w-full rounded-md overflow-hidden', bgClass]" :style="{ height: `${Number(height)}px` }" :title="tooltip">
      <div v-if="indeterminate" class="p-indeterminate w-full h-full origin-[0_50%] bg-opacity-50" :class="bgColor"></div>
      <template v-else>
        <div
          v-bind="$attrs"
          :class="[ 'absolute top-0 h-full rounded-md transition-all duration-1000', bgColor]"
          :style="{ width: `${percent}%` }"
        ></div>
        <div v-if="!noText" class="absolute top-0 left-0 flex h-full w-full items-center justify-center text-sm">
          <slot>{{ percent }}%</slot>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

defineOptions({
  inheritAttrs: false
})

const { height = 4, type = 'primary', bgClass = 'bg-neutral-200/50 dark:bg-neutral-600' } = defineProps<{
  percent?: number
  height?: number | string
  tooltip?: string
  indeterminate?: boolean
  wrapperClass?: string
  noText?: boolean
  bgClass?: string
  type?: 'primary' | 'success' | 'info' | 'warning' | 'danger' | 'purple'
}>()

const bgColor = computed(() => {
  return {
    primary: 'bg-[--c-primary-500]',
    success: 'bg-emerald-400',
    info: 'bg-sky-400',
    warning: 'bg-amber-400',
    danger: 'bg-red-400',
    purple: 'bg-[#B606F0]'
  }[type?.toLowerCase() || 'primary']
})
</script>

<style scoped lang="scss">
.p-indeterminate {
  animation: indeterminateAnimation 1s infinite linear;
}

@keyframes indeterminateAnimation {
  0% { transform: translateX(0) scaleX(0); }
  40% { transform: translateX(0) scaleX(0.4); }
  100% { transform: translateX(100%) scaleX(0.5); }
}
</style>